import { dehydrate, HydrationBoundary as TanstackHydrationBoundary } from '@tanstack/react-query';
import type { PropsWithChildren, ReactNode } from 'react';

import { getQueryClient } from '../lib/getQueryClient.js';

type HydrationBoundaryProps = PropsWithChildren;

/**
 * HydrationBoundary component that will serialize the Tanstack QueryClient object to be sent to a client component for hydration.
 *
 * @param root0 Component props object
 * @param root0.children Component JSX children
 * @returns HydrationBoundary component
 */
export function HydrationBoundary({ children }: HydrationBoundaryProps): ReactNode {
  const queryClient = getQueryClient();

  return <TanstackHydrationBoundary state={dehydrate(queryClient)}>{children}</TanstackHydrationBoundary>;
}
